import { MipDropdown } from '@dealstack/frontend/app/pages/Project/DealDashboard/MipDropdown/MipDropdown';
import { ROUTES } from '@dealstack/frontend/app/pages/Routing/routes';
import { SummaryDealMip } from '@dealstack/shared/lib/generated';
import { generatePath } from 'react-router-dom';
import { AddBreadcrumbItem } from './useBreadcrumbs.types';

export const makeMipPageBreadcrumbs = ({
	mipName,
	mipId,
	dealId,
	mips,
	createNewMip,
}: {
	mipName?: string;
	mipId?: string;
	dealId?: string;
	mips?: SummaryDealMip[];
	createNewMip: () => void;
}): AddBreadcrumbItem[] => {
	return [
		{
			name: mipName || 'Mip',
			url: generatePath(ROUTES.DEAL, { dealId: dealId ?? '' }),
			element: (
				<MipDropdown
					key="mip-dropdown"
					currentDealId={dealId}
					currentMipId={mipId}
					mips={mips || []}
					createNewMip={createNewMip}
				/>
			),
		},
	];
};
